import { MuiColorInput, matchIsValidColor } from 'mui-color-input';
import { useEffect, useState } from 'react';

import { Modal } from 'shared/ui/Modal';

interface EditBrandInfoModalProps {
  handleChangeBrandColor: (value: string) => void;
  handleCloseModal: () => void;
  isModalOpen: boolean;
  isUpdatingBrand: boolean;
  approveNameButton: string;
  selectedBrandColor?: string;
  error?: boolean | undefined;
}

export const EditBrandInfoModal = ({
  handleChangeBrandColor,
  handleCloseModal,
  isModalOpen,
  isUpdatingBrand,
  approveNameButton,
  selectedBrandColor,
  error,
}: EditBrandInfoModalProps) => {
  const [isInvalidColor, setIsInvalidColor] = useState<boolean>(false);
  const [brandColor, setBrandColor] = useState<string>(
    selectedBrandColor || '',
  );

  const handleMuiColorInputChange = (value: string) => {
    setBrandColor(value);
    if (matchIsValidColor(value)) {
      setIsInvalidColor(false);
    } else {
      setIsInvalidColor(true);
    }
  };

  const handleSubmitModal = () => {
    if (brandColor && matchIsValidColor(brandColor)) {
      handleChangeBrandColor?.(brandColor);
    }
  };

  useEffect(() => {
    setBrandColor(selectedBrandColor || '');
  }, [selectedBrandColor]);

  return (
    <Modal
      disabled={error || isInvalidColor || isUpdatingBrand}
      isModalOpen={isModalOpen}
      isLoading={isUpdatingBrand}
      handleCloseModal={handleCloseModal}
      handleSubmitModal={handleSubmitModal}
      approveNameButton={approveNameButton}
    >
      <MuiColorInput
        sx={{
          width: '100%',
        }}
        label="Brand Color"
        format="hex"
        value={brandColor}
        isAlphaHidden={true}
        onChange={handleMuiColorInputChange}
      />
    </Modal>
  );
};
